import * as React from 'react'
import { MenuLinks } from '../../../components/Navigation/MenuLinks'
import { useOptimizelyObfuscation } from '@/hooks/useOptimizelyObfuscation'

interface Props {
  className?: string
  aboveFoldExperimentation?: boolean
}

export const DesktopMenu: React.FC<Props> = ({
  className,
  aboveFoldExperimentation,
}) => {
  const { hidden, optimizelyConfigured } = useOptimizelyObfuscation(
    aboveFoldExperimentation,
  )

  return (
    <section className={className}>
      {hidden && !optimizelyConfigured ? null : <MenuLinks />}
    </section>
  )
}
